import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function AccountsPage(){return <ExtendedModulePage moduleKey="accounts"/>}
